/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
// import EmptyScreenBranch from '../components/EmptyScreen';
import CardHeader from '../../../components/CardHeader';
import moment from 'moment';
import { removeAssociationSelection } from '../../ManageAssociation/AssociationSlice';
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import { purchaseOrderList , DateFilter} from './PurchaseOrderListSlice';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Table from './Components/Table';
import Debounce from '../../../CommonMethods/Debounce';
import Filter from './../TopBarComponents/Filter'
import Search from '../TopBarComponents/Search';
import Toast from '../../../components/Toast';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';

const PurchaseOrder = () => {
    const { setToastErrorMessage, toastErrorMessage, setToastmessage, isInactiveBranch, reloadFY, setReloadFY } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const PurchaseOrderList = useSelector(state => state.purchaseOrderListSlice);
    const { List} = PurchaseOrderList
    const {userType}=useSelector(state=>state.auth)
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const navigate = useNavigate('')
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({});
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const [filterCount, setFilterCount] = useState(0)
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [finacialYear, setFinacialYear] = useState('')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [FYLoading, setFYLoading] = useState(true);
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setSearchParams({ page_number:  1 })
    }

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    /* The above code is defining a function called `getPurcheseOrderList` using the `useCallback` hook
    in React. This function is an asynchronous function that makes an API call to retrieve a list of
    purchase orders. */
    const getPurcheseOrderList = useCallback(async () => {
        try {
            setLoading(true);
            const branch_id = await GetBranchId()
            const body = `${
                searchParams.get("page_number") === null ? "" : `&page_number=${searchParams.get("page_number")}`}${
                searchParams.get("limit") === null ? "" : `&limit=${searchParams.get("limit")}`}${
                searchParams.get("filter") === null ? "" : `&filter=${searchParams.get("filter")}`}${
                searchParams.get("status") === null ? "" : `&status=${encodeURIComponent(searchParams.get("status")?.replace(/ /g, "-"))}`}${
                searchParams.get("start_date") === null ? `&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams.get("start_date")}`}${
                searchParams.get("search") === null ? "" : `&search=${searchParams.get("search")}`}${
                searchParams.get("end_date") === null ? `&end_date=${endDate.substring(0, 10)}` : `&end_date=${searchParams.get("end_date")}`}${
                searchParams?.get('sort') === null 
                    ? '' 
                    : `&sort=${encodeURIComponent(searchParams.get('sort'))}`
            }`
            dispatch(purchaseOrderList(`purchase-order?filter=true&branch_id=${branch_id}&${body}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0 && searchParams.get('filter')===null ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            updateFilterCheckBox()
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            handleLoadData()
        }
    }, [location, FYLoading]);



    const calculateEndDate = (fyEndDate) =>
    {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString(): fyEndDate;
    }
    
    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    useEffect(()=>{
        getFinancialYears()
    },[])

    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getPurcheseOrderList(); }, [getPurcheseOrderList]);` is a hook that is used to run
    the `getPurcheseOrderList` function whenever the `getPurcheseOrderList` function changes. In this case,
    the `getPurcheseOrderList` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getPurcheseOrderList` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        if (startDate != null && !FYLoading ){
            getPurcheseOrderList()
        }
        getFilterData();
        return(()=>{
            dispatch(removeAssociationSelection())
        })
    }, [searchParams, startDate, FYLoading]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`branch/${confirmationState.item._id}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Branch ${state} successfully`);
            }
            handleConformationClick();
            getPurcheseOrderList();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong. Please try again")
        }
    }
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
            status: searchParams.get('status')
        };
            // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
                
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };

    /**
         * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
         * the filter open state.
         */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('PO_date')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
        element. In this case, it is used to detect clicks outside of the filter component. When a click is
        detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
        is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
         * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
         * object's id, dateString, and selectedFilter.
         */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            setReloadFY(false);
        }
    }, [reloadFY]);

    /**
     * The function `handleApplyFilter` is used to apply filters to a search and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } 
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({});            
            setSelectedDateRange('Financial Year')
            setSelectedName(currentFinacialYear)
            if(reloadFY)
            {
                const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
                setCurrentFinacialYear(selectedFY.name)
                if (selectedFY) {
                    setStartDate(selectedFY.start_date);
                    setEndDate(calculateEndDate(selectedFY.end_date));
                }
            }
            setSelectedName(currentFinacialYear)
            setFilterCheckBox([])
            setSelectedFilter('date_range')
        }
        getCount(type)
    }

    /**
     * The function `getFilterData` retrieves filter data, sets the filter data in state, parses the
     * search parameters, sets the filter checkbox values in state, counts the number of filters
     * applied, and dispatches a date filter action.
     */
    const getFilterData = async() => {
        let resp={
            PO_date : [],
            PO_status : ["Undelivered", "Partially Delivered", "Delivered"]
        }
        setFilterData(resp)
        let filter_val = {}
        Object.keys(resp).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)
            let count = 0
            Object.keys(filter_val).map((item) =>  {
                
                if(filter_val[item]?.length !== 0) {
                    if(item!=="end_date"){
                        count += 1
                    }
                }
            })
            setFilterCount(count)
        })
        dispatch(DateFilter(filter_val))
    }

    return (
        <>
            <CardHeader noPadding>          
                <div
                    className="mainDataCntnrTop shadow-s13">
                    <div className="flex items-center">
                        <h5 class=" pageHeader adderror">
                            Purchase Orders
                        </h5>
                    </div>
                    <div className='flex items-center'>
                        {<Search
                            SearchValue={searchFieldDebounce}
                            handleOnClickSearch={setsearchFieldDebounce}
                            optimizedFn={optimizedFn}
                            customSearchPlaceHolder={`PO # / Vendor Name`}
                        />}
                        {<div class="relative">
                            <button onClick={() => {
                                if(loading){return}
                                handleOpenFilter()
                            }} type="button" id="filter_btn">
                                <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]" />
                                <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                                {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                            </button>
                            {isFilterOpen &&
                                <Filter
                                    filterCount={filterCount}
                                    selectedDateRange={selectedDateRange}
                                    setSelectedDateRange={setSelectedDateRange}
                                    selectedName={selectedName}
                                    setSelectedName={setSelectedName}
                                    searchParams={searchParams}
                                    ref={outSideClick}
                                    currentFinacialYear={currentFinacialYear}
                                    handleSelectObject={handleSelectObject}
                                    FilterCheckbox={FilterCheckbox}
                                    setFilterCheckBox={setFilterCheckBox}
                                    FilterData={FilterData}
                                    handleApplyFilter={handleApplyFilter}
                                    setIsFilterOpen={setIsFilterOpen}
                                    selectedFilter={selectedFilter}
                                    setSelectedFilter={setSelectedFilter}
                                    radioButton={true}
                                    finacialYear={finacialYear}
                                    setSearchParams={setSearchParams}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                    dateRangeDropdownOptions={[{ name: 'Financial Year' }, { name: 'Custom' }]}
                                    calculateEndDate={calculateEndDate}
                                />}
                        </div>}
                        {!isInactiveBranch && <button onClick={() =>navigate('/inventory-master/purchase-order/add-purchase-order')} id="addAdmin_user" className="prmy-btn">
                            Create Purchase Order
                        </button>}
                    </div>
                    {toastErrorMessage !== "" && (
                        <Toast
                            message={toastErrorMessage}
                            type="error"
                            setToastmessage={setToastErrorMessage}
                        />
                    )}
                </div>
                <div className='mainDataCntnrListDiv scrollBlue_thick'>

                    {loading ? <ItemShimmer classkey={"mt-[32px]"}/>
                        : <>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                searchParams={searchParams}
                                setLoading={setLoading}
                                startDate={startDate} 
                                endDate={endDate}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </>
                    }
                </div>
            </CardHeader>            
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Branch`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this Branch ?`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default PurchaseOrder;
